// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Navbar_wrap__H2QRL","burgerWrap":"Navbar_burgerWrap__dkr_g"};